export default {
  checklist: (payload) =>
    `checklist?category=${payload.category}&type=${payload.type}`,
};
